import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFF" stroke="#979593" strokeMiterlimit="10" d="M23.086 2.5H9.5a1 1 0 00-1 1v25a1 1 0 001 1h19a1 1 0 001-1V8.914a1 1 0 00-.293-.707l-5.414-5.414a1 1 0 00-.707-.293z"/>
        <path fill="none" stroke="#979593" strokeMiterlimit="10" d="M23.5 2.5v5a1 1 0 001 1h5"/>
        <path fill="#C8C6C4" d="M26.5 15h-5a.5.5 0 010-1h5a.5.5 0 010 1zm0 2h-5a.5.5 0 010-1h5a.5.5 0 010 1zm0 2h-5a.5.5 0 010-1h5a.5.5 0 010 1zm0 2h-5a.5.5 0 010-1h5a.5.5 0 010 1zm0 2h-5a.5.5 0 010-1h5a.5.5 0 010 1zm-7-8h-4a.5.5 0 010-1h4a.5.5 0 010 1zm0 2h-4a.5.5 0 010-1h4a.5.5 0 010 1zm0 2h-4a.5.5 0 010-1h4a.5.5 0 010 1zm0 2h-4a.5.5 0 010-1h4a.5.5 0 010 1zm0 2h-4a.5.5 0 010-1h4a.5.5 0 010 1z"/>
        <path fill="#107C41" d="M3.5 25h11a1.5 1.5 0 001.5-1.5v-11a1.5 1.5 0 00-1.5-1.5h-11A1.5 1.5 0 002 12.5v11A1.5 1.5 0 003.5 25z"/>
        <path fill="#F9F7F7" d="M6 22l2.174-4.01L6.182 14h1.602l1.087 2.549c.1.242.169.423.206.542h.015c.071-.194.146-.382.224-.564L10.478 14h1.47l-2.042 3.967L12 22h-1.565L9.18 19.2a2.568 2.568 0 01-.15-.375h-.018a1.93 1.93 0 01-.145.363L7.574 22H6z"/>
    </svg>
)

export default class IconMSExcel extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
